// extracted by mini-css-extract-plugin
export var formContainer = "_ey-0";
export var message = "_ey-1";